// extracted by mini-css-extract-plugin
export default {"item":"ActivitiesSegments_item__3LUFI","icon":"ActivitiesSegments_icon__hX7A1"};